<template>

  <v-content>

    <v-overlay :value="overlay">

      <v-progress-circular indeterminate size="64"></v-progress-circular>

    </v-overlay>

    <v-snackbar v-model="snackbars.errorSnackbar" color="error">

      Please fix the error(s) on the form.

      <template v-slot:action="{ attrs }">

        <v-btn text v-bind="attrs" @click="snackbars.errorSnackbar = false">

          <v-icon>mdi-close-circle</v-icon>

        </v-btn>

      </template>

    </v-snackbar>

    <v-snackbar v-model="snackbars.genericInfoSnackbar" color="primary">

      {{ snackbars.genericInfoText }}

      <template v-slot:action="{ attrs }">

        <v-btn text v-bind="attrs" @click="snackbars.genericInfoSnackbar = false">

          <v-icon>mdi-close-circle</v-icon>

        </v-btn>

      </template>

    </v-snackbar>

    <v-snackbar v-model="snackbars.genericErrorSnackbar" color="error">

      {{ snackbars.genericErrorText }}

      <template v-slot:action="{ attrs }">

        <v-btn text v-bind="attrs" @click="snackbars.genericErrorSnackbar = false">

          <v-icon>mdi-close-circle</v-icon>

        </v-btn>

      </template>

    </v-snackbar>

    <v-snackbar v-model="snackbars.emailAlreadyExistsSnackbar" color="error">

      This email has already been used to create an account.  Click <router-link to="/Login" style="color: white">here</router-link> to sign in.

      <template v-slot:action="{ attrs }">

        <v-btn text v-bind="attrs" @click="snackbars.emailAlreadyExistsSnackbar = false">

          <v-icon>mdi-close-circle</v-icon>

        </v-btn>

      </template>

    </v-snackbar>

    <v-dialog v-model="registrationSuccessfulDialog" persistent max-width="400">

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>Verification Link Sent</strong></v-card-title>

        <v-card-text class="text-body-1">

          <p>Please check your email for a verification link.</p>

          <p>You must click on the link in the email to complete creating the account.</p>

          <p>You may need to check your spam folder.</p>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn @click="registrationSuccessfulOk" color="primary">ok</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-layout align-center justify-center>

      <v-card elevation="0" class="pb-2" min-width="400px" max-width="450">

        <v-card-title class="text-h5 word-break"><strong>Sign up</strong></v-card-title>

        <v-card-text>

          <p>Please create an account to use the system by completing the fields below:</p>

          <v-text-field label="Email" v-model="registrationInfo.email" type="text" :error-messages="emailErrors" maxlength="100" outlined></v-text-field>

          <v-text-field label="Password" v-model="registrationInfo.password" type="password" :error-messages="passwordErrors" maxlength="30" outlined></v-text-field>

          <v-text-field label="Confirm Password" v-model="registrationInfo.confirmPassword" type="password" :error-messages="confirmPasswordErrors" maxlength="30" outlined></v-text-field>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn color="primary" class="mr-2" @click="register">sign up</v-btn>

        </v-card-actions>

        <v-card-text>

          <hr />

          <v-alert icon="mdi-information-outline">

            <strong>Already have an account?</strong><p>Click <a @click="navigateToLogin">here</a> to sign in to your account.</p>

          </v-alert>

        </v-card-text>

      </v-card>

    </v-layout>

  </v-content>

</template>

<script lang="ts">

import Vue from 'vue'

import axios from "axios";

import {minLength, required} from "vuelidate/lib/validators";

function validateEmail(value: string | null) {

  return value == null || value == "" || value.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) !== null;

}

function validateMatchesPassword(value: any, data: { password: string | null; }) {

  return (value == data.password);

}

export default Vue.extend({

  name: 'Register',

  created()
  {
    // implement security (kick out if needed)

    if (this.$store.state.user.email != null && this.$store.state.user.email != '')
    {
      if (this.$route.path != '/Form') this.$router.push('/Form');
    }

  },

  data: () =>
  {
    return {

      overlay: false,

      snackbars: {

        errorSnackbar: false,

        genericErrorSnackbar: false,

        emailAlreadyExistsSnackbar: false,

        genericErrorText: '',

        genericInfoSnackbar: false,

        genericInfoText: '',

      },

      registrationSuccessfulDialog: false,

      registrationInfo:
          {
            email: '',

            password: '',

            confirmPassword: ''
          }

    };
  },

  methods:
      {
        navigateToLogin() {

          if (this.$route.path != '/Login') this.$router.push('/Login');

        },

        registrationSuccessfulOk()
        {
          this.$router.push('/');
        },

        clearSnackbars(){

          this.snackbars.errorSnackbar = false;

          this.snackbars.emailAlreadyExistsSnackbar = false;

          this.snackbars.genericInfoSnackbar = false;

          this.snackbars.genericErrorSnackbar = false;

        },

        async register() {

          this.$v.registrationInfo.$touch();

          if (!this.$v.registrationInfo.$invalid) {

            this.clearSnackbars();

            this.overlay = true;

            setTimeout(async () => {

              let obj = await axios.post('accounts/register', this.registrationInfo);

              this.overlay = false;

              if (obj.data == '%%EMAIL_ALREADY_EXISTS%%') {

                this.snackbars.emailAlreadyExistsSnackbar = true;

                return;

              }

              this.registrationSuccessfulDialog = true;

            }, 100);

          } else {

            this.snackbars.errorSnackbar = true;

          }

        }
      },

  validations:
      {
        registrationInfo:
            {
              email: {

                required,

                validateEmail

              },

              password: {

                required,

                minLength: minLength(8)

              },

              confirmPassword: {

                required,

                minLength: minLength(8),

                validateMatchesPassword

              }
            }
      },

  computed:
      {
        emailErrors()
        {
          if (this.$v.registrationInfo.email && !this.$v.registrationInfo.email.$dirty) return [];

          if (this.$v.registrationInfo.email && !this.$v.registrationInfo.email.required) return ['Email is required.'];

          if (this.$v.registrationInfo.email && !this.$v.registrationInfo.email.validateEmail) return ['Email is invalid.'];

          return null;
        },

        passwordErrors()
        {
          if (this.$v.registrationInfo.password && !this.$v.registrationInfo.password.$dirty) return [];

          if (this.$v.registrationInfo.password && !this.$v.registrationInfo.password.required) return ['Password is required.'];

          if (this.$v.registrationInfo.password && !this.$v.registrationInfo.password.minLength) return ['Password must be at least 8 characters.'];

          return null;
        },

        confirmPasswordErrors()
        {
          if (this.$v.registrationInfo.confirmPassword && !this.$v.registrationInfo.confirmPassword.$dirty) return [];

          if (this.$v.registrationInfo.confirmPassword && !this.$v.registrationInfo.confirmPassword.required) return ['Confirm Password is required.'];

          if (this.$v.registrationInfo.confirmPassword && !this.$v.registrationInfo.confirmPassword.minLength) return ['Confirm Password must be at least 8 characters.'];

          if (this.$v.registrationInfo.confirmPassword && !this.$v.registrationInfo.confirmPassword.validateMatchesPassword) return ['Confirm Password must match Password.'];

          return null;
        }

      }

})

</script>

<style>

.word-break {

  word-break: break-word;

}

.v-messages__message {

  font-size: 14px !important;

}

th > .v-icon {

  color: white !important;

}

</style>
